const customerPaths: string[] = [
  "singleSiteQuote/airx/customer",
  "dashboard/customer/vendor",
  "singleSiteQuoteResults/airx/customer",
  "multiSiteResults/airx/customer",
  "multiSiteManual/airx/customer",
  "quotes/customer",
  "singleManualQuote/airx/customer",
  "quoteLine/airx/customer",
  "quoteLine/customer",
  "user/airx/customer/vendor",
  "company/vendor/customer",
  "register/newUser",
  "documents/customer/vendor",
  "buildings/customer/vendor",
  "services/customer/vendor",
  "user/airx/customer/vendor"
];
export default customerPaths;
